import { CommonActions, StackActions, } from '@react-navigation/native';
/** Copy more than one of the duplicate review's screens shows. */
export const duplicateReviewStrings = {
    // Only shown when the review has more than one group.
    progress: (step, total) => total > 1 ? `Possible duplicate ${step + 1}/${total}` : undefined,
    // The review's button, which the other screens repeat or quote.
    alreadyCancelled: (count) => count > 2 ? 'I’ve already cancelled' : 'I’ve already cancelled one',
};
/**
 * Moves the duplicate review on to its next group. The current review screen
 * and every path screen above it are swapped for a new review screen, so the
 * next group comes in as a new screen rather than by going back.
 */
export const continueDuplicateReview = (navigation, params) => navigation.dispatch((state) => {
    const reviewIndex = state.routes.findLastIndex((route) => route.name === 'DuplicateReview');
    const kept = reviewIndex === -1 ? state.routes : state.routes.slice(0, reviewIndex);
    const previousKey = reviewIndex === -1 ? 'DuplicateReview' : state.routes[reviewIndex].key;
    const routes = [
        ...kept,
        {
            key: `${previousKey}-${params.step ?? 0}`,
            name: 'DuplicateReview',
            params,
        },
    ];
    return CommonActions.reset({
        ...state,
        routes,
        index: routes.length - 1,
    });
});
/**
 * Leaves the duplicate review for the screen it started from, popping the
 * review and every screen above it.
 */
export const exitDuplicateReview = (navigation) => {
    const { routes } = navigation.getState();
    const reviewIndex = routes.findLastIndex((route) => route.name === 'DuplicateReview');
    navigation.dispatch(StackActions.pop(reviewIndex === -1 ? 1 : routes.length - reviewIndex));
};
/**
 * The web URL for the duplicate review's screens, without their params: the group
 * list and step stay in route params.
 */
export const getDuplicateReviewPath = (route) => {
    switch (route.name) {
        case 'DuplicateReview': {
            const subscriptionIds = route.params?.subscriptionIds;
            // One subscription's group, as opened from its detail screen.
            return subscriptionIds?.length === 1
                ? `/subscriptions/${subscriptionIds[0]}/duplicates`
                : '/subscriptions/duplicates';
        }
        case 'DuplicateKeepReasons':
            return '/subscriptions/duplicates/keep';
        case 'DuplicateCancel':
            return '/subscriptions/duplicates/cancel';
        case 'DuplicateCancelled':
            return '/subscriptions/duplicates/cancelled';
        default:
            return undefined;
    }
};
